<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 24L1.65516 18C0.579328 16.1379 0 14.069 0 11.9172C0 5.37933 5.37933 0 11.9586 0C18.5379 0 24 5.37933 24 11.9172C24 18.4551 18.5379 24 11.9586 24C9.88964 24 7.90345 23.3379 6.12412 22.3448L0 24Z" fill="#EDEDED"/>
<path d="M6.4554 20.1925L6.82782 20.3994C8.35885 21.3511 10.1382 21.9304 12.0002 21.9304C17.4209 21.9304 21.9313 17.4201 21.9313 11.9166C21.9313 6.41316 17.4209 2.06836 11.9589 2.06836C6.49679 2.06836 2.06921 6.45455 2.06921 11.9166C2.06921 13.8201 2.60715 15.6821 3.60025 17.2545L3.84854 17.627L2.89684 21.1028L6.4554 20.1925Z" fill="#55CD6C"/>
<path d="M8.77235 6.37245L7.98616 6.33105C7.73787 6.33105 7.48962 6.41384 7.3241 6.57935C6.95168 6.91038 6.33101 7.53105 6.16549 8.35868C5.87585 9.60007 6.33101 11.0897 7.40688 12.5794C8.48276 14.069 10.5517 16.469 14.1931 17.5035C15.3517 17.8345 16.262 17.6276 17.0069 17.1724C17.5862 16.8 17.9586 16.2207 18.0828 15.6L18.2069 15.0207C18.2483 14.8552 18.1655 14.6483 18 14.5655L15.3931 13.3655C15.2276 13.2828 15.0206 13.3241 14.8965 13.4897L13.862 14.8138C13.7793 14.8966 13.6551 14.9379 13.531 14.8966C12.8276 14.6483 10.4689 13.6552 9.18616 11.1724C9.14477 11.0483 9.14477 10.9241 9.22755 10.8414L10.2206 9.7242C10.3034 9.60007 10.3448 9.43456 10.3034 9.31038L9.10343 6.62074C9.06199 6.49657 8.93787 6.37245 8.77235 6.37245Z" fill="#FEFEFE"/>
</svg>

</template>

<script>
export default {

}
</script>

<style>

</style>